import React from 'react';
import { IllustrationError, InlineExternalLink } from '@monash/portal-react';
import c from './local-error.module.scss';

const LocalError = ({
  title = 'Sorry, we are currently having trouble retrieving data.',
  message = (
    <p>
      Please try again later or alternatively you can visit{' '}
      <InlineExternalLink
        mode="canvas"
        link="https://www.monash.edu"
        text="monash.edu"
      />
    </p>
  ),
}) => {
  // TODO: team to decide and implement proper way for live screen reader announcements
  return (
    <div className={c.container}>
      <div className={c.illustration}>
        <IllustrationError />
      </div>
      <h1>{title}</h1>
      {message}
    </div>
  );
};
export default LocalError;
